/**
 * This function will create the correct redirectUrl parameter for the /login url
 * @param {*} specific url to create the 'redirectUrl' param
 */
export const getReturnUrl = redirectURL =>
    `?returnUrl=${redirectURL ? redirectURL : window.location.pathname}`;
